<div class="search-option">
  <mat-icon svgIcon="twc:quote" class="entity-icon"></mat-icon>

  <div class="details">
    <div class="title-row">
      <span class="twc-typography-body-1 twc-color-primary-typeface"
        >#{{ option().id }}</span
      >
      <nx-quote-request-status
        [status]="option().status"
        class="ml-8"
      ></nx-quote-request-status>
    </div>

    <div
      class="subline auto-ellipsis twc-typography-body-2 twc-color-secondary-typeface"
    >
      {{
        option().quoteNumber || option().bolNumber || option().proNumber || '—'
      }}
    </div>
  </div>
</div>
